/* eslint-disable @typescript-eslint/naming-convention */
import { Injectable } from "@angular/core";
import { RealtimeChannel, SupabaseClient, createClient } from "@supabase/supabase-js";
import { environment } from "src/environments/environment";
import { StorageObject } from "../interfaces/StorageObjects";
import { AuthStorage } from "src/app/core/storage/auth-storage.class";
import { LocationTrackingDto } from "src/app/tracking/interfaces/location_tracking";
import { Store } from "@ngrx/store";
import { upsertTracking, upsertTrackingSuccess } from "src/app/tracking/ngrx/tracking.actions";

@Injectable({
  providedIn: "root",
})
export class RealTimeService {
  private supabase: SupabaseClient;

  constructor(private store: Store<any>) {
    this.supabase = createClient(
      environment.supabaseClientConfig.supabaseUrl,
      environment.supabaseClientConfig.supabaseKey,
      {
        auth: {
          storage: new AuthStorage(),
          autoRefreshToken: true,
          persistSession: true,
          detectSessionInUrl: false,
        },
      }
    );
  }

  connectToReportGeneration(userId: string): Promise<string | null> {
    return new Promise((resolve) => {
      const timeout = setTimeout(async () => {
        resolve(null); // Resolve with false if the file is not generated
      }, 60000); // 1 minute

      this.supabase
        .channel("table-db-changes")
        .on(
          "postgres_changes",
          { event: "*", schema: "storage", table: "objects" },
          (payload) => {
            if ((payload.new as StorageObject).path_tokens.includes(userId)) {
              clearTimeout(timeout); // Clear the timeout
              resolve((payload.new as StorageObject).name); // Resolve with the file ID
            }
          }
        )
        .subscribe();
    });
  }

  connectToTracking(appointmentId: number): RealtimeChannel {
    return this.supabase
      .channel("table-db-changes")
      .on(
        "postgres_changes",
        { event: "*", schema: "public", table: "location_tracking" },
        (payload) => {
          if (
            (payload.new as LocationTrackingDto).appointment_id ===
            appointmentId
          ) {
            this.store.dispatch(
              upsertTrackingSuccess({
                tracking: payload.new as LocationTrackingDto,
              })
            );
          }
        }
      );
  }
}
